(function () {
    // ====== CALCULATION LOGIC MAPPING (EDITABLE) ======
    // Maps collection grouping metafields to their calculation logic type
    const CALCULATION_TYPE_MAP = {
        'custom.heating_capacity_btus_': 'BTU',
        'custom.system_tonnage': 'TONNAGE',
        'custom.system_tonnage_ductless': 'BTU_DUCTLESS'
    };
    // ===================================================

    const modal = document.querySelector('[data-system-modal]');
    const modalTriggers = document.querySelectorAll('[data-system-modal-trigger]');
    const modalCloses = document.querySelectorAll('[data-system-modal-close]');
    const form = document.querySelector('[data-system-form]');
    const backButton = document.querySelector('[data-system-back]');
    const steps = document.querySelectorAll('[data-step]');
    const collectionSelector = document.querySelector('[data-collection-selector]');
    
    let sizingDataCache = {
        btu: null,
        tonnage: null
    };

    // ====== JSON CDN: ensure collections data is ready (load on page load, reuse existing loader) ======
    // CDN JSON stores price like collection page: dollars = price/10000 (e.g. 8920000 = $892.00)
    function formatPriceFromJson(priceFromJson) {
        const num = typeof priceFromJson === 'string' ? parseFloat(priceFromJson) : Number(priceFromJson);
        if (typeof num !== 'number' || isNaN(num)) return '';
        var dollars = num / 10000;
        return '$' + dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function adaptProductsForFindSystem(loaderProducts) {
        if (!loaderProducts || !Array.isArray(loaderProducts)) return [];
        return loaderProducts.map(function (p) {
            const flat = {
                id: p.id,
                title: p.title,
                handle: p.handle,
                url: p.url,
                price: p.price,
                compare_at_price: p.compare_at_price,
                available: p.available !== false,
                featured_image: p.featured_image || p.featured_media || null,
                vendor: p.vendor || '',
                sku: (p.selected_or_first_available_variant && p.selected_or_first_available_variant.sku) || (p.variants && p.variants[0] && p.variants[0].sku) || '',
                variant_id: (p.selected_or_first_available_variant && p.selected_or_first_available_variant.id) || (p.variants && p.variants[0] && p.variants[0].id) || null,
                price_formatted: formatPriceFromJson(p.price),
                compare_at_price_formatted: (p.compare_at_price != null && p.compare_at_price !== '') ? formatPriceFromJson(p.compare_at_price) : null
            };
            if (p.metafields && p.metafields.custom) {
                Object.keys(p.metafields.custom).forEach(function (k) {
                    const v = p.metafields.custom[k];
                    let val = (v && v.value !== undefined) ? v.value : v;
                    if (Array.isArray(val) && val.length > 0) {
                        val = val[0];
                    }
                    flat[k] = val;
                });
            }
            return flat;
        });
    }

    function ensureCollectionsDataReady() {
        if (window._findSystemCollectionsDataReady) {
            return window._findSystemCollectionsDataReady;
        }
        if (!window.systemCollectionsJsonUrl || !window.systemCollectionsMeta || !window.systemCollectionsMeta.length) {
            window._findSystemCollectionsDataReady = Promise.resolve();
            return window._findSystemCollectionsDataReady;
        }
        window._findSystemCollectionsDataReady = (function () {
            var loader = window._collectionJsonLoader || window._pdpCollectionJsonLoader;
            if (loader && loader.isLoaded && loader.isLoaded()) {
                window.systemCollectionsData = window.systemCollectionsMeta.map(function (meta) {
                    var products = loader.getProductsByHandle(meta.handle);
                    return {
                        handle: meta.handle,
                        title: meta.title,
                        groupingMetafield: meta.groupingMetafield,
                        variantOptions: meta.variantOptions,
                        products: adaptProductsForFindSystem(products)
                    };
                });
                return Promise.resolve();
            }
            if (typeof CollectionJsonLoader === 'undefined') {
                return new Promise(function (resolve) {
                    var attempts = 0;
                    function wait() {
                        if (typeof CollectionJsonLoader !== 'undefined') {
                            runLoad().then(resolve);
                            return;
                        }
                        if (attempts >= 50) return resolve();
                        attempts++;
                        setTimeout(wait, 100);
                    }
                    wait();
                });
            }
            function runLoad() {
                loader = new CollectionJsonLoader(window.systemCollectionsJsonUrl);
                return loader.load().then(function () {
                    window._collectionJsonLoader = loader;
                    window.systemCollectionsData = window.systemCollectionsMeta.map(function (meta) {
                        var products = loader.getProductsByHandle(meta.handle);
                        return {
                            handle: meta.handle,
                            title: meta.title,
                            groupingMetafield: meta.groupingMetafield,
                            variantOptions: meta.variantOptions,
                            products: adaptProductsForFindSystem(products)
                        };
                    });
                });
            }
            return runLoad();
        })();
        return window._findSystemCollectionsDataReady;
    }

    // Initialize: load JSON on page load so data is ready before user submits
    ensureCollectionsDataReady().then(function () {
        initializeCollectionDropdown();
    });

    // ====== INITIALIZATION ======
    function initializeCollectionDropdown() {
        if (!collectionSelector || !window.systemCollectionsData) return;
        
        // Clear existing options except the first one
        collectionSelector.innerHTML = '<option value="">Select system type</option>';
        
        // Populate with valid collections
        window.systemCollectionsData.forEach((collection, index) => {
            const option = document.createElement('option');
            option.value = index; // Use index as value
            option.textContent = collection.title;
            collectionSelector.appendChild(option);
        });
    }

    // ====== SIZING DATA LOADERS ======
    async function loadSizingData(type) {
        if (sizingDataCache[type]) {
            return sizingDataCache[type];
        }
        
        try {
            const url = window.systemSizingData[type];
            if (!url) throw new Error(`No sizing data URL for type: ${type}`);
            
            const response = await fetch(url);
            const data = await response.json();
            sizingDataCache[type] = data;
            return data;
        } catch (error) {
            return null;
        }
    }

    // ====== BTU CALCULATION (Furnace Logic) ======
    function calculateBTURequirement(zone, squareFeet, insulationQuality) {
        return loadSizingData('btu').then(sizingData => {
            if (!sizingData || !sizingData.zones) {
                throw new Error('BTU sizing data not available');
            }

            const zoneNumber = parseInt(zone.replace(/\D/g, '')) || 1;
            const sqft = parseInt(squareFeet);
            const zoneConfig = sizingData.zones[zoneNumber.toString()];
            
            if (!zoneConfig) {
                throw new Error(`Zone ${zoneNumber} configuration not found`);
            }

            // Determine heating factor based on insulation quality
            let heatingFactor;
            if (insulationQuality === 'well-insulated') {
                heatingFactor = zoneConfig.min_btu_per_sqft;
            } else {
                // For poor insulation or unsure, use maximum value
                heatingFactor = zoneConfig.max_btu_per_sqft;
            }

            // Calculate BTUs needed
            const btusNeeded = sqft * heatingFactor;
            
            return {
                btusNeeded,
                heatingFactor,
                tonnage: calculateTonnageFromBTU(btusNeeded)
            };
        });
    }

    function calculateTonnageFromBTU(btus) {
        // Convert BTUs to tons (12,000 BTU = 1 ton)
        const tons = btus / 12000;
        // Round to nearest 0.5 ton increment
        return Math.round(tons * 2) / 2;
    }

    // ====== BTU EXTRACTION FOR DUCTLESS SYSTEMS ======
    function extractBTUFromDuctless(value) {
        // Extracts BTU from formats like "36,000 BTU / 3 Ton"
        if (!value) return null;
        
        const valueStr = value.toString();
        // Match the BTU number before "BTU"
        const btuMatch = valueStr.match(/([\d,]+)\s*BTU/i);
        
        if (btuMatch && btuMatch[1]) {
            // Remove commas and parse
            const btuValue = parseFloat(btuMatch[1].replace(/,/g, ''));
            return isNaN(btuValue) ? null : btuValue;
        }
        
        return null;
    }

    function filterProductsByBTUDuctless(products, recommendedBTUs, groupingMetafield) {
        const groupingKey = groupingMetafield.replace('custom.', '');
        
        // Get all unique BTU sizes from products (extracting from "BTU / Ton" format)
        const btuSizes = new Set();
        const productsWithBTU = products.map(product => {
            const ductlessValue = getMetafieldValue(product, groupingKey);
            
            if (!ductlessValue) return null;
            
            // Extract BTU from "36,000 BTU / 3 Ton" format
            const productBTUs = extractBTUFromDuctless(ductlessValue);
            
            if (!productBTUs) return null;
            btuSizes.add(productBTUs);
            return { product, btuSize: productBTUs };
        }).filter(Boolean);
        
        // Sort BTU sizes
        const sortedBTUSizes = Array.from(btuSizes).sort((a, b) => a - b);
        
        // Find size below (strictly < calculated) and size above (> calculated)
        let lowerSize = null;
        let exactMatch = null;
        let upperSize = null;
        
        for (let i = 0; i < sortedBTUSizes.length; i++) {
            if (sortedBTUSizes[i] === recommendedBTUs) {
                exactMatch = sortedBTUSizes[i];
                // Get lower and upper around the exact match
                if (i > 0) lowerSize = sortedBTUSizes[i - 1];
                if (i < sortedBTUSizes.length - 1) upperSize = sortedBTUSizes[i + 1];
                break;
            } else if (sortedBTUSizes[i] < recommendedBTUs) {
                lowerSize = sortedBTUSizes[i];
            } else if (!upperSize && sortedBTUSizes[i] > recommendedBTUs) {
                upperSize = sortedBTUSizes[i];
                break;
            }
        }
        
        // Handle edge cases
        if (!lowerSize && !exactMatch && sortedBTUSizes.length > 0) {
            lowerSize = sortedBTUSizes[0];
        }
        if (!upperSize && !exactMatch && sortedBTUSizes.length > 0) {
            upperSize = sortedBTUSizes[sortedBTUSizes.length - 1];
        }
        
        // Determine sizes to show
        let sizesToShow, closestSize;
        
        if (exactMatch) {
            // Exact match: show lower, exact, upper (3 sizes)
            sizesToShow = [lowerSize, exactMatch, upperSize].filter(Boolean);
            closestSize = exactMatch;
        } else {
            // No exact match: show lower and upper (2 sizes)
            sizesToShow = [lowerSize, upperSize].filter(Boolean);
            // Determine which is closest
            if (lowerSize && upperSize) {
                const diffToLower = Math.abs(recommendedBTUs - lowerSize);
                const diffToUpper = Math.abs(recommendedBTUs - upperSize);
                closestSize = diffToLower <= diffToUpper ? lowerSize : upperSize;
            } else {
                closestSize = upperSize || lowerSize;
            }
        }
        
        const filteredProducts = productsWithBTU
            .filter(item => sizesToShow.includes(item.btuSize))
            .map(item => ({
                ...item.product,
                isRecommendedSize: item.btuSize === closestSize,
                sortBTUSize: item.btuSize
            }));
        
        // Sort by BTU size ascending
        return filteredProducts.sort((a, b) => a.sortBTUSize - b.sortBTUSize);
    }

    function filterProductsByBTU(products, recommendedBTUs, groupingMetafield) {
        const groupingKey = groupingMetafield.replace('custom.', '');
        
        // Get all unique BTU sizes from products
        const btuSizes = new Set();
        const productsWithBTU = products.map(product => {
            const heatingCapacity = getMetafieldValue(product, groupingKey);
            
            if (!heatingCapacity) return null;
            
            // Parse BTU value (handles "60k" or "60000")
            const heatingCapacityStr = heatingCapacity.toString().toLowerCase();
            const productBTUs = heatingCapacityStr.includes('k')
                ? parseFloat(heatingCapacityStr.replace(/[^0-9.]/g, '')) * 1000
                : parseFloat(heatingCapacityStr.replace(/[^0-9.]/g, ''));
            
            if (isNaN(productBTUs)) return null;
            btuSizes.add(productBTUs);
            return { product, btuSize: productBTUs };
        }).filter(Boolean);
        
        // Sort BTU sizes
        const sortedBTUSizes = Array.from(btuSizes).sort((a, b) => a - b);
        
        // Find size below (strictly < calculated) and size above (> calculated)
        let lowerSize = null;
        let exactMatch = null;
        let upperSize = null;
        
        for (let i = 0; i < sortedBTUSizes.length; i++) {
            if (sortedBTUSizes[i] === recommendedBTUs) {
                exactMatch = sortedBTUSizes[i];
                // Get lower and upper around the exact match
                if (i > 0) lowerSize = sortedBTUSizes[i - 1];
                if (i < sortedBTUSizes.length - 1) upperSize = sortedBTUSizes[i + 1];
                break;
            } else if (sortedBTUSizes[i] < recommendedBTUs) {
                lowerSize = sortedBTUSizes[i];
            } else if (!upperSize && sortedBTUSizes[i] > recommendedBTUs) {
                upperSize = sortedBTUSizes[i];
                break;
            }
        }
        
        // Handle edge cases
        if (!lowerSize && !exactMatch && sortedBTUSizes.length > 0) {
            lowerSize = sortedBTUSizes[0];
        }
        if (!upperSize && !exactMatch && sortedBTUSizes.length > 0) {
            upperSize = sortedBTUSizes[sortedBTUSizes.length - 1];
        }
        
        // Determine sizes to show
        let sizesToShow, closestSize;
        
        if (exactMatch) {
            // Exact match: show lower, exact, upper (3 sizes)
            sizesToShow = [lowerSize, exactMatch, upperSize].filter(Boolean);
            closestSize = exactMatch;
        } else {
            // No exact match: show lower and upper (2 sizes)
            sizesToShow = [lowerSize, upperSize].filter(Boolean);
            // Determine which is closest
            if (lowerSize && upperSize) {
                const diffToLower = Math.abs(recommendedBTUs - lowerSize);
                const diffToUpper = Math.abs(recommendedBTUs - upperSize);
                closestSize = diffToLower <= diffToUpper ? lowerSize : upperSize;
            } else {
                closestSize = upperSize || lowerSize;
            }
        }
        
        const filteredProducts = productsWithBTU
            .filter(item => sizesToShow.includes(item.btuSize))
            .map(item => ({
                ...item.product,
                isRecommendedSize: item.btuSize === closestSize,
                sortBTUSize: item.btuSize
            }));
        
        // Sort by BTU size ascending
        return filteredProducts.sort((a, b) => a.sortBTUSize - b.sortBTUSize);
    }

    // ====== TONNAGE CALCULATION (AC Logic) ======
    function getRecommendedTonnage(zone, squareFeet, insulationQuality) {
        return loadSizingData('tonnage').then(sizingData => {
            if (!sizingData || sizingData.length === 0) {
                throw new Error('Tonnage sizing data not available');
            }

            const zoneNumber = parseInt(zone.replace(/\D/g, '')) || 1;
            const sqft = parseInt(squareFeet);
            
            // Find base tonnage from sizing data
            let baseTonnage = null;
            
            for (const tonnageConfig of sizingData) {
                const zoneConfig = tonnageConfig.zones[zoneNumber.toString()];
                if (zoneConfig && sqft >= zoneConfig.min_sqft && sqft <= zoneConfig.max_sqft) {
                    baseTonnage = tonnageConfig.tonnage_tons;
                    break;
                }
            }
            
            // If no exact match, find closest
            if (!baseTonnage) {
                let closestMatch = null;
                let closestDifference = Infinity;
                
                for (const tonnageConfig of sizingData) {
                    const zoneConfig = tonnageConfig.zones[zoneNumber.toString()];
                    if (zoneConfig) {
                        const midPoint = (zoneConfig.min_sqft + zoneConfig.max_sqft) / 2;
                        const difference = Math.abs(sqft - midPoint);
                        
                        if (difference < closestDifference) {
                            closestDifference = difference;
                            closestMatch = tonnageConfig.tonnage_tons;
                        }
                    }
                }
                baseTonnage = closestMatch || 2.5;
            }
            
            return baseTonnage;
        });
    }

    function filterProductsByTonnage(products, recommendedTonnage, groupingMetafield) {
        const groupingKey = groupingMetafield.replace('custom.', '');
        
        // Get all unique tonnage sizes from products
        const tonnageSizes = new Set();
        const productsWithTonnage = products.map(product => {
            const tonnageValue = getMetafieldValue(product, groupingKey);
            
            if (!tonnageValue) return null;
            
            // Parse tonnage
            const productTonnage = parseFloat(tonnageValue.toString().replace(/[^\d.]/g, ''));
            
            if (isNaN(productTonnage)) return null;
            
            tonnageSizes.add(productTonnage);
            return { product, tonnageSize: productTonnage };
        }).filter(Boolean);
        
        // Sort tonnage sizes
        const sortedTonnageSizes = Array.from(tonnageSizes).sort((a, b) => a - b);
        
        // Find size below (strictly < calculated) and size above (> calculated)
        let lowerSize = null;
        let exactMatch = null;
        let upperSize = null;
        
        for (let i = 0; i < sortedTonnageSizes.length; i++) {
            if (sortedTonnageSizes[i] === recommendedTonnage) {
                exactMatch = sortedTonnageSizes[i];
                // Get lower and upper around the exact match
                if (i > 0) lowerSize = sortedTonnageSizes[i - 1];
                if (i < sortedTonnageSizes.length - 1) upperSize = sortedTonnageSizes[i + 1];
                break;
            } else if (sortedTonnageSizes[i] < recommendedTonnage) {
                lowerSize = sortedTonnageSizes[i];
            } else if (!upperSize && sortedTonnageSizes[i] > recommendedTonnage) {
                upperSize = sortedTonnageSizes[i];
                break;
            }
        }
        
        // Handle edge cases
        if (!lowerSize && !exactMatch && sortedTonnageSizes.length > 0) {
            lowerSize = sortedTonnageSizes[0];
        }
        if (!upperSize && !exactMatch && sortedTonnageSizes.length > 0) {
            upperSize = sortedTonnageSizes[sortedTonnageSizes.length - 1];
        }
        
        // Determine sizes to show
        let sizesToShow, closestSize;
        
        if (exactMatch) {
            // Exact match: show lower, exact, upper (3 sizes)
            sizesToShow = [lowerSize, exactMatch, upperSize].filter(Boolean);
            closestSize = exactMatch;
        } else {
            // No exact match: show lower and upper (2 sizes)
            sizesToShow = [lowerSize, upperSize].filter(Boolean);
            // Determine which is closest
            if (lowerSize && upperSize) {
                const diffToLower = Math.abs(recommendedTonnage - lowerSize);
                const diffToUpper = Math.abs(recommendedTonnage - upperSize);
                closestSize = diffToLower <= diffToUpper ? lowerSize : upperSize;
            } else {
                closestSize = upperSize || lowerSize;
            }
        }
        
        const filteredProducts = productsWithTonnage
            .filter(item => sizesToShow.includes(item.tonnageSize))
            .map(item => ({
                ...item.product,
                isRecommendedSize: item.tonnageSize === closestSize,
                sortTonnageSize: item.tonnageSize
            }));
        
        // Sort by tonnage size ascending
        return filteredProducts.sort((a, b) => a.sortTonnageSize - b.sortTonnageSize);
    }

    // ====== HELPER FUNCTIONS ======
    function getMetafieldValue(product, key) {
        if (!key || !product) return null;
        
        const normalizedKey = key.replace('custom.', '');
        
        let value = null;
        
        // Direct property access
        if (product[key] !== undefined && product[key] !== null) {
            value = product[key];
        } else if (product[normalizedKey] !== undefined && product[normalizedKey] !== null) {
            value = product[normalizedKey];
        } else {
            // Try without trailing underscore
            const withoutUnderscore = normalizedKey.replace(/_+$/, '');
            if (product[withoutUnderscore] !== undefined && product[withoutUnderscore] !== null) {
                value = product[withoutUnderscore];
            } else {
                // Case-insensitive match
                for (const prop in product) {
                    if (prop.toLowerCase() === normalizedKey.toLowerCase()) {
                        value = product[prop];
                        break;
                    }
                }
            }
        }
        
        // Handle array values (Shopify list metafields come as arrays)
        if (value !== null && Array.isArray(value)) {
            return value.length > 0 ? value[0] : null;
        }
        // Handle stringified array (e.g. "[\"option label\"]" from some APIs)
        if (typeof value === 'string' && value.trim().indexOf('[') === 0) {
            try {
                const parsed = JSON.parse(value);
                if (Array.isArray(parsed) && parsed.length > 0) return parsed[0];
            } catch (e) { /* ignore */ }
        }
        
        return value;
    }

    function determineCalculationType(groupingMetafield) {
        return CALCULATION_TYPE_MAP[groupingMetafield] || null;
    }

    function parseVariantOptions(variantOptionsArray) {
        if (!variantOptionsArray || !Array.isArray(variantOptionsArray)) return [];
        
        return variantOptionsArray.map(option => {
            // Split on first colon only
            const colonIndex = option.indexOf(':');
            if (colonIndex === -1) return null;
            
            const label = option.substring(0, colonIndex).trim();
            const metafield = option.substring(colonIndex + 1).trim();
            
            if (!label || !metafield) return null;
            
            return { label, metafield };
        }).filter(Boolean);
    }

    // ====== PRODUCT GROUPING ======
    function groupProducts(products, groupingMetafield) {
        
        const groupingKey = groupingMetafield.replace('custom.', '');
        const groups = new Map();
        
        products.forEach(product => {
            const groupingValue = getMetafieldValue(product, groupingKey);
            
            if (!groupingValue) {
                // Ungrouped product
                const key = `ungrouped_${product.id}`;
                groups.set(key, {
                    representativeProduct: product,
                    groupedProducts: [product],
                    isGrouped: false,
                    isRecommendedSize: product.isRecommendedSize || false
                });
                return;
            }
            
            const compositeKey = String(groupingValue).toLowerCase().replace(/\s+/g, '_');
            
            if (!groups.has(compositeKey)) {
                groups.set(compositeKey, {
                    representativeProduct: product,
                    groupedProducts: [],
                    isGrouped: true,
                    isRecommendedSize: product.isRecommendedSize || false
                });
            }
            
            groups.get(compositeKey).groupedProducts.push(product);
        });
        
        return Array.from(groups.values());
    }

    // ====== RENDERING ======
    function renderGroupedCard(group, variantOptions) {
        const product = group.representativeProduct;
        const isGrouped = group.isGrouped && group.groupedProducts.length > 1;
        
        const imageUrl = product.featured_image?.url || product.image?.url || product.featured_image || '';
        const imageAlt = product.featured_image?.alt || product.title || '';
        
        // Enhance products with metafield mapping for custom element compatibility
        let enhancedProducts = group.groupedProducts;
        if (isGrouped && variantOptions && variantOptions.length > 0) {
            enhancedProducts = group.groupedProducts.map(prod => {
                const enhanced = { ...prod };
                
                // Add metafield_1, metafield_2, metafield_3 for custom element compatibility
                variantOptions.forEach((option, index) => {
                    const metafieldKey = option.metafield.replace('custom.', '');
                    const value = getMetafieldValue(prod, metafieldKey);
                    enhanced[`metafield_${index + 1}`] = value;
                });
                
                return enhanced;
            });
        }
        
        const productDataJson = isGrouped ? JSON.stringify(enhancedProducts) : '';
        
        // Show recommended badge
        const showBadge = window.systemFinderConfig?.showRecommendedBadge && group.isRecommendedSize;
        const badgeText = window.systemFinderConfig?.recommendedBadgeText || 'Recommended';
        
        return `
            <${isGrouped ? 'grouped-product-card-furnace' : 'div'} class="product-card ${showBadge ? 'recommended' : ''}">
                ${showBadge ? `<div class="product-badge recommended-badge">${badgeText}</div>` : ''}
                <a href="${product.url}" data-product-link>
                    <div class="product-image">
                        <img 
                            src="${imageUrl}" 
                            alt="${imageAlt}"
                            loading="lazy"
                            data-product-image
                        >
                    </div>
                </a>
                <div class="product-info">
                    ${product.vendor ? `<p class="product-vendor" data-product-vendor>${product.vendor}</p>` : ''}
                    <h4 class="product-title" data-product-title>${product.title}</h4>
                    
                    ${isGrouped ? renderVariantSelectors(group, variantOptions) : ''}
                    
                    <div class="product-price" data-product-price>
                        ${renderSimplePrice(product)}
                    </div>
                    <a href="${product.url}" class="product-link btn" data-product-button>View Product</a>
                </div>
                ${isGrouped ? `<script type="application/json">${productDataJson}</script>` : ''}
            </${isGrouped ? 'grouped-product-card-furnace' : 'div'}>
        `;
    }

    // ====== SORTING UTILITY ======
    function sortOptionValues(values) {
        // Convert to array if it's a Set
        const valuesArray = Array.isArray(values) ? values : Array.from(values);
        
        if (valuesArray.length === 0) return valuesArray;
        
        // Detect the type of values and sort accordingly
        return valuesArray.sort((a, b) => {
            const aStr = String(a).trim();
            const bStr = String(b).trim();
            
            // Try to extract numeric value with units (e.g., "60K BTU", "2 Ton", "2.5 Ton")
            const aNumMatch = aStr.match(/^(\d+(?:\.\d+)?)\s*[KkTt]?\s*/);
            const bNumMatch = bStr.match(/^(\d+(?:\.\d+)?)\s*[KkTt]?\s*/);
            
            // Both have numeric values - sort numerically
            if (aNumMatch && bNumMatch) {
                const aNum = parseFloat(aNumMatch[1]);
                const bNum = parseFloat(bNumMatch[1]);
                return aNum - bNum;
            }
            
            // Try to extract percentage values (e.g., "80%", "95%")
            const aPercentMatch = aStr.match(/^(\d+(?:\.\d+)?)\s*%/);
            const bPercentMatch = bStr.match(/^(\d+(?:\.\d+)?)\s*%/);
            
            if (aPercentMatch && bPercentMatch) {
                const aNum = parseFloat(aPercentMatch[1]);
                const bNum = parseFloat(bPercentMatch[1]);
                return aNum - bNum;
            }
            
            // Try pure numeric values (e.g., "1", "2", "3")
            const aNum = parseFloat(aStr);
            const bNum = parseFloat(bStr);
            
            if (!isNaN(aNum) && !isNaN(bNum)) {
                return aNum - bNum;
            }
            
            // Fall back to alphabetical sorting for text values
            return aStr.localeCompare(bStr);
        });
    }

    function renderVariantSelectors(group, variantOptions) {
        if (!variantOptions || variantOptions.length === 0) return '';
        
        let html = '';
        
        variantOptions.forEach((option, num) => {
            const metafieldKey = option.metafield.replace('custom.', '');
            
            const uniqueValues = new Set();
            
            group.groupedProducts.forEach(product => {
                const value = getMetafieldValue(product, metafieldKey);
                
                if (value) {
                    const normalizedValue = String(value).trim();
                    if (normalizedValue) {
                        uniqueValues.add(normalizedValue);
                    }
                }
            });
            
            if (uniqueValues.size > 0) {
                // Sort the values before rendering
                const sortedValues = sortOptionValues(uniqueValues);
                
                const selectorNum = num + 1; // 1-indexed
                html += `
                    <div class="product-variant-selector">
                        <span class="variant-selector-label">Select ${option.label}:</span>
                        <div class="variant-options">
                            ${sortedValues.map((value, index) => `
                                <div class="variant-option">
                                    <input 
                                        type="radio" 
                                        name="variant-selector-${selectorNum}-${group.representativeProduct.id}" 
                                        value="${value}" 
                                        id="variant-${selectorNum}-system-${group.representativeProduct.id}-${index}"
                                        ${index === 0 ? 'checked' : ''}
                                    >
                                    <label for="variant-${selectorNum}-system-${group.representativeProduct.id}-${index}" class="variant-swatch">
                                        ${value}
                                    </label>
                                </div>
                            `).join('')}
                        </div>
                    </div>
                `;
            }
        });
        
        return html;
    }

    function renderSimplePrice(product) {
        var displayPrice = product.price_formatted || (product.price != null ? formatPriceFromJson(product.price) : '');
        var displayCompare = product.compare_at_price_formatted || (product.compare_at_price != null ? formatPriceFromJson(product.compare_at_price) : '');
        if (product.compare_at_price && product.compare_at_price > product.price && displayCompare) {
            return `
                <span class="product-price-compare">${displayCompare}</span>
                <span class="product-price-current">${displayPrice}</span>
            `;
        }
        return `<span class="product-price-current">${displayPrice}</span>`;
    }

    // ====== EVENT HANDLERS ======
    
    // Open modal (any element with data-system-modal-trigger can open it)
    if (modal) {
        modalTriggers.forEach(trigger => {
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                modal.classList.add('active');
                document.body.style.overflow = 'hidden';
            });
        });
    }

    // Close modal
    modalCloses.forEach(close => {
        close.addEventListener('click', () => {
            modal.classList.remove('active');
            document.body.style.overflow = '';
            showStep(1);
        });
    });

    // Form submission
    form?.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(form);
        const zone = formData.get('zone');
        const sqft = formData.get('square_feet');
        const insulationQuality = formData.get('insulation_quality');
        const collectionIndex = parseInt(formData.get('collection'));

        // Ensure JSON is loaded (no loading UI; data is usually ready from page load)
        await ensureCollectionsDataReady();

        // Get selected collection
        const selectedCollection = window.systemCollectionsData[collectionIndex];
        
        if (!selectedCollection) {
            alert('Please select a valid system type');
            return;
        }

        // Get human-readable insulation text
        let insulationText;
        switch(insulationQuality) {
            case 'well-insulated':
                insulationText = 'Well-insulated + newer windows';
                break;
            case 'poor-insulation':
                insulationText = 'Poor insulation + older windows';
                break;
            case 'unsure':
                insulationText = 'Unsure about insulation';
                break;
            default:
                insulationText = insulationQuality;
        }

        // Display selected values
        document.querySelector('[data-selected-zone]').textContent = zone;
        document.querySelector('[data-selected-sqft]').textContent = sqft + ' sq ft';
        document.querySelector('[data-selected-insulation]').textContent = insulationText;
        document.querySelector('[data-selected-collection]').textContent = selectedCollection.title;

        // Show step 2
        showStep(2);

        // Determine calculation type
        const calculationType = determineCalculationType(selectedCollection.groupingMetafield);
        
        if (!calculationType) {
            document.querySelector('[data-product-grid]').innerHTML = 
                '<p class="system-loading">Error: Unable to determine calculation type for this collection.</p>';
            return;
        }

        try {
            let recommendedProducts = [];
            let calculationInfo = '';

            if (calculationType === 'BTU') {
                // BTU-based calculation (Furnace)
                const recommendation = await calculateBTURequirement(zone, sqft, insulationQuality);
                recommendedProducts = filterProductsByBTU(
                    selectedCollection.products, 
                    recommendation.btusNeeded,
                    selectedCollection.groupingMetafield
                );
                
                calculationInfo = `
                    <p data-heating-factor><strong>Heating Factor:</strong> ${recommendation.heatingFactor} BTU/sq ft</p>
                    <p data-recommended-btu><strong>Recommended BTUs:</strong> ${recommendation.btusNeeded.toLocaleString()} BTUs</p>
                `;
            } else if (calculationType === 'BTU_DUCTLESS') {
                // Ductless systems use AC tonnage calculation, then convert to BTU for filtering
                const recommendedTonnage = await getRecommendedTonnage(zone, sqft, insulationQuality);
                const recommendedBTUs = recommendedTonnage * 12000; // Convert tons to BTU
                
                recommendedProducts = filterProductsByBTUDuctless(
                    selectedCollection.products, 
                    recommendedBTUs,
                    selectedCollection.groupingMetafield
                );
                
                calculationInfo = `
                    <p data-recommended-tonnage><strong>Recommended Tonnage:</strong> ${recommendedTonnage} Tons</p>
                    <p data-recommended-btu><strong>Recommended BTUs:</strong> ${recommendedBTUs.toLocaleString()} BTUs</p>
                `;
            } else if (calculationType === 'TONNAGE') {
                // Tonnage-based calculation (AC)
                const recommendedTonnage = await getRecommendedTonnage(zone, sqft, insulationQuality);
                recommendedProducts = filterProductsByTonnage(
                    selectedCollection.products,
                    recommendedTonnage,
                    selectedCollection.groupingMetafield
                );
                
                calculationInfo = `
                    <p data-recommended-tonnage><strong>Recommended Tonnage:</strong> ${recommendedTonnage} Tons</p>
                `;
            }

            // Display calculation info
            const selectedInfo = document.querySelector('.system-selected-info');
            if (selectedInfo) {
                // Remove existing calculation info
                const existingCalcInfo = selectedInfo.querySelectorAll('[data-heating-factor], [data-recommended-btu], [data-recommended-tonnage]');
                existingCalcInfo.forEach(el => el.remove());
                
                selectedInfo.innerHTML += calculationInfo;
            }

            // Parse variant options from collection
            const variantOptions = parseVariantOptions(selectedCollection.variantOptions);
            
            // Load recommendations
            loadSystemRecommendations(recommendedProducts, selectedCollection.groupingMetafield, variantOptions);
            
            // Trigger custom event
            const event = new CustomEvent('systemFinderSubmit', {
                detail: { 
                    zone, 
                    square_feet: sqft,
                    insulation_quality: insulationQuality,
                    collection: selectedCollection.title,
                    calculation_type: calculationType,
                    recommended_products: recommendedProducts
                }
            });
            document.dispatchEvent(event);
            
        } catch (error) {
            document.querySelector('[data-product-grid]').innerHTML = 
                '<p class="system-loading">Error loading recommendations. Please try again.</p>';
        }
    });

    // Back button
    backButton?.addEventListener('click', () => {
        showStep(1);
        // Clear calculation results
        const selectedInfo = document.querySelector('.system-selected-info');
        if (selectedInfo) {
            const calcInfo = selectedInfo.querySelectorAll('[data-heating-factor], [data-recommended-btu], [data-recommended-tonnage]');
            calcInfo.forEach(el => el.remove());
        }
    });

    // Show specific step
    function showStep(stepNumber) {
        const closeButtonStep1 = document.querySelector('.system-modal-close-step1');
        const closeButtonStep2 = document.querySelector('.system-modal-close-step2');
        
        steps.forEach(step => {
            step.style.display = step.dataset.step === String(stepNumber) ? 'block' : 'none';
        });
        
        if (stepNumber === 1) {
            if (closeButtonStep1) closeButtonStep1.style.display = 'block';
            if (closeButtonStep2) closeButtonStep2.style.display = 'none';
        } else if (stepNumber === 2) {
            if (closeButtonStep1) closeButtonStep1.style.display = 'none';
            if (closeButtonStep2) closeButtonStep2.style.display = 'block';
        }
    }

    // Function to load and display recommendations
    window.loadSystemRecommendations = function (products, groupingMetafield, variantOptions) {
        const grid = document.querySelector('[data-product-grid]');
        if (!grid) return;

        if (products && products.length > 0) {
            const groupedProducts = groupProducts(products, groupingMetafield);
            
            grid.innerHTML = groupedProducts.map(group => 
                renderGroupedCard(group, variantOptions)
            ).join('');
            
            // Initialize grouped product cards
            setTimeout(() => {
                const groupedCards = grid.querySelectorAll('grouped-product-card-furnace');
                groupedCards.forEach(card => {
                    if (!card.initialized) {
                        card.initialized = true;
                        if (card.init && typeof card.init === 'function') {
                            card.init();
                        }
                    }
                });
            }, 50);
        } else {
            grid.innerHTML = '<p class="system-loading">No matching products found for your specifications. Please try adjusting your criteria.</p>';
        }
    };

    // ====== VISUAL SECTION SWIPER ======
    function initVisualSwiper() {
        const root = document.querySelector('.find-system-visual');
        if (!root) return;

        const swiperContainer = root.querySelector('.find-system-visual__swiper');
        if (!swiperContainer) return;

        if (typeof Swiper === 'undefined') {
            console.warn('Swiper.js is not loaded');
            return;
        }

        let swiperInstance = null;
        const breakpoint = 1280;

        function initSwiper() {
            if (window.innerWidth < breakpoint && !swiperInstance) {
                swiperInstance = new Swiper(swiperContainer, {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    grabCursor: true,
                    freeMode: {
                        enabled: true,
                        sticky: false
                    }
                });
            }
        }

        function destroySwiper() {
            if (window.innerWidth >= breakpoint && swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstance = null;
            }
        }

        function handleResize() {
            if (window.innerWidth < breakpoint) {
                initSwiper();
            } else {
                destroySwiper();
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);
    }

    // Initialize visual swiper on DOMContentLoaded
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVisualSwiper);
    } else {
        initVisualSwiper();
    }
})();
